import axios from "axios";
import { RouteType } from "../../constants/RouteType";
import { msgTypes } from "../../constants/msgTypes";
import { AuthModel } from "../../model/utilModels/AuthModel";
import { ResponseModel } from "../../model/utilModels/ResponseModel";
import ApiUrl from "../shared/ApiUrl";
import axiosEncrypted from "../axios/axiosEncrypted";
import { json } from "stream/consumers";
var CryptoJS = require("crypto-js");

export class AuthService {
  static getEncryptText = async (plaintText: string) => {
    let _key = CryptoJS.enc.Utf8.parse(msgTypes.APP_SECRET_KEY.KEY);
    let _iv = CryptoJS.enc.Utf8.parse(msgTypes.APP_SECRET_KEY.IV);
    let encrypted = CryptoJS.AES.encrypt(plaintText, _key, {
      keySize: 32,
      iv: _iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    });
    return encrypted.toString();
  };

  static getCryptoRequest = async (
    apiUrl: string,
    params: Record<string, any> = {}
  ) => {
    const fullUrl = ApiUrl.baseUrl + apiUrl;

    try {
      // Convert query params into a stringified JSON and encrypt it
      let requestObj: any = null;

      if (Object.keys(params).length > 0) {
        const jsonStr = JSON.stringify(params);
        const obj = JSON.parse(jsonStr);

        // const encryptedData = await AuthService.getEncryptText(jsonStr);
        requestObj = { params: obj.params };
      } else {
        requestObj = { params: {} };
      }

      const encryptRes = await axiosEncrypted.get<string>(fullUrl, {
        ...requestObj,
        headers: {
          "Content-Type": "application/json",
          // "ngrok-skip-browser-warning": "true",
        },
        responseType: "text" as "json",
      });

      let response = new ResponseModel();
      if (encryptRes && encryptRes.data) {
        const decryptRes = await AuthService.getDecryptText(
          JSON.parse(encryptRes.data)
        );
        response = JSON.parse(decryptRes);
      }

      return response;
    } catch (error) {
      console.error("GET request error:", error);
      throw error;
    }
  };

  //Decryption
  static getDecryptText = async (encrypted: string) => {
    let _key = CryptoJS.enc.Utf8.parse(msgTypes.APP_SECRET_KEY.KEY);
    let _iv = CryptoJS.enc.Utf8.parse(msgTypes.APP_SECRET_KEY.IV);

    let decrypted = CryptoJS.AES.decrypt(encrypted, _key, {
      keySize: 32,
      iv: _iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    }).toString(CryptoJS.enc.Utf8);

    return decrypted;
  };

  //For Encryprtion and Decryption
  static postCryptoRequest = async (
    apiUrl: string,
    requestJsonStr: string | FormData
  ) => {
    apiUrl = ApiUrl.baseUrl + apiUrl + "/";

    //prepare encrypted string request body
    let requestObj: any = null;
    if (!(requestJsonStr instanceof FormData)) {
      if (requestJsonStr?.length > 0) {
        const encrypteddata = await AuthService.getEncryptText(requestJsonStr);
        requestObj = {
          data: encrypteddata,
        };
      } else {
        requestObj = requestJsonStr;
      }
    } else {
      requestObj = requestJsonStr;
    }
    const encryptRes = await axiosEncrypted.post<string>(apiUrl, requestObj, {
      responseType: "text" as "json",
    });
    let response = new ResponseModel();
    if (encryptRes != undefined) {
      const decryptRes = await AuthService.getDecryptText(
        JSON.parse(encryptRes?.data)
      );
      response = JSON.parse(decryptRes);
    }
    return response;
  };
  static postCryptoRequestWithoutSlash = async (
    apiUrl: string,
    requestJsonStr: string | FormData
  ) => {
    apiUrl = ApiUrl.baseUrl + apiUrl;

    //prepare encrypted string request body
    let requestObj: any = null;
    if (!(requestJsonStr instanceof FormData)) {
      if (requestJsonStr?.length > 0) {
        const encrypteddata = await AuthService.getEncryptText(requestJsonStr);
        requestObj = {
          data: encrypteddata,
        };
      } else {
        requestObj = requestJsonStr;
      }
    } else {
      requestObj = requestJsonStr;
    }
    const encryptRes = await axiosEncrypted.post<string>(apiUrl, requestObj, {
      responseType: "text" as "json",
    });
    let response = new ResponseModel();
    if (encryptRes != undefined) {
      const decryptRes = await AuthService.getDecryptText(
        JSON.parse(encryptRes?.data)
      );
      response = JSON.parse(decryptRes);
    }
    return response;
  };

  // PATCH request with encryption and decryption
  static patchCryptoRequest = async (
    apiUrl: string,
    requestJsonStr: string | FormData
  ) => {
    const fullUrl = ApiUrl.baseUrl + apiUrl + "/";

    let requestObj: any = null;
    if (!(requestJsonStr instanceof FormData)) {
      if (requestJsonStr?.length > 0) {
        const encryptedData = await AuthService.getEncryptText(requestJsonStr);
        requestObj = {
          data: encryptedData,
        };
      } else {
        requestObj = requestJsonStr;
      }
    } else {
      requestObj = requestJsonStr;
    }

    const encryptRes = await axiosEncrypted.patch<string>(fullUrl, requestObj, {
      responseType: "text" as "json",
    });

    let response = new ResponseModel();
    if (encryptRes !== undefined) {
      const decryptRes = await AuthService.getDecryptText(
        JSON.parse(encryptRes?.data)
      );
      response = JSON.parse(decryptRes);
    }

    return response;
  };
  // PUT request with encryption and decryption
  static putCryptoRequest = async (
    apiUrl: string,
    requestJsonStr: string | FormData
  ) => {
    const fullUrl = ApiUrl.baseUrl + apiUrl + "/";

    let requestObj: any = null;
    if (!(requestJsonStr instanceof FormData)) {
      if (requestJsonStr?.length > 0) {
        const encryptedData = await AuthService.getEncryptText(requestJsonStr);
        requestObj = {
          data: encryptedData,
        };
      } else {
        requestObj = requestJsonStr;
      }
    } else {
      requestObj = requestJsonStr;
    }

    const encryptRes = await axiosEncrypted.put<string>(fullUrl, requestObj, {
      responseType: "text" as "json",
    });

    let response = new ResponseModel();
    if (encryptRes != undefined) {
      const decryptRes = await AuthService.getDecryptText(
        JSON.parse(encryptRes?.data)
      );
      response = JSON.parse(decryptRes);
    }

    return response;
  };
  static deleteCryptoRequest = async (
    apiUrl: string,
    params: Record<string, any> = {}
  ) => {
    const fullUrl = ApiUrl.baseUrl + apiUrl + "/";

    let requestObj: any = { params: {}, responseType: "text" as "json" };

    if (Object.keys(params).length > 0) {
      const jsonStr = JSON.stringify(params);
      const encryptedData = await AuthService.getEncryptText(jsonStr);
      requestObj.params = { data: encryptedData };
    }

    const encryptRes = await axiosEncrypted.delete<string>(fullUrl, requestObj);

    let response = new ResponseModel();
    if (encryptRes && encryptRes.data) {
      const decryptRes = await AuthService.getDecryptText(
        JSON.parse(encryptRes.data)
      );
      response = JSON.parse(decryptRes);
    }

    return response;
  };
}
